"use client";
import Link from "next/link";
import { useState } from "react";

export default function Accordion({ children, className="", open=false, disabled=false }) {
  const [isOpen, set_isOpen] = useState(open)
  return (
    <div className={`accordion-contianer ${className}${isOpen?" open":""}${disabled?" disabled":""}`} onClick={() => {
      if(!disabled)set_isOpen((prev) => !prev)
    }}>
      {children}
    </div>
  );
}
